const useAgenziaConfigTable = () => {
  return [
    { key: "denominazione", label: "Ragione sociale" },
    { key: "indirizzo", label: "Indirizzo" },
    { key: "cap", label: "CAP" },
    { key: "citta", label: "Città" },
    { key: "provincia", label: "Provincia" },
    { key: "piva", label: "Partita IVA" },
  ];
};

export default useAgenziaConfigTable;
